var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhpIcoTk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7c4-3 9 0 9 4v6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17c-2 2-5 2-7 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhpIcoTk);
export default __webpack_public_path__ + "static/media/whp-ico-tk.045eb6825892f897af2d10d373a1aee6.svg";
export { ForwardRef as ReactComponent };